export type CelluliteGradeValue = string | null

export interface CelluliteGradeOption {
    key: string
    label: string
    description: string
    tooltip: string
}

export const CELLULITE_GRADE_OPTIONS: CelluliteGradeOption[] = [
    {
        key: '01',
        label: 'Grau 01',
        description: 'Covinhas visíveis apenas ao beliscar a pele ou contrair a musculatura',
        tooltip: 'Pele lisa em repouso, sem alterações visíveis em pé ou deitado — as covinhas só aparecem ao beliscar a pele ou contrair o músculo.',
    },
    {
        key: '02',
        label: 'Grau 02',
        description: 'Covinhas visíveis espontaneamente em pé, sem precisar beliscar',
        tooltip: 'Aspecto de "casca de laranja" leve, visível espontaneamente com a pessoa em pé, mas que desaparece quando deitada.',
    },
    {
        key: '03',
        label: 'Grau 03',
        description: 'Covinhas visíveis em pé e deitado, com nódulos e ondulações evidentes',
        tooltip: 'Nódulos e ondulações evidentes, visíveis tanto em pé quanto deitado, sem precisar contrair a musculatura ou beliscar a pele.',
    },
    {
        key: '04',
        label: 'Grau 04',
        description: 'Nódulos profundos e dolorosos, com flacidez e ondulações acentuadas',
        tooltip: 'Forma mais avançada: nódulos profundos, por vezes dolorosos à palpação, associados a flacidez e ondulações acentuadas visíveis em qualquer posição.',
    },
]

export function findCelluliteGrade(key: CelluliteGradeValue): CelluliteGradeOption | null {
    return CELLULITE_GRADE_OPTIONS.find((option) => option.key === key) ?? null
}

export function isCelluliteGradeValueEmpty(value: CelluliteGradeValue | undefined): boolean {
    return !value
}
